/**
 * Attendre que le CSS soit chargé dans le dom avant de révéler le corp de la page.
 */
document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
    document.body.style.visibility = 'visible';
  }
};

require('../style.scss');

/**
 * Required CSS
 */
require('normalize.css/normalize.css');
require('../assets/css/normalize-fixes.css');
require('../assets/css/themes/stable.css');
require('../assets/css/themes/classy.css');
require('../assets/css/bootstrap.css');
require('../assets/icomoon/style.css');
require('../assets/css/style.css');

/**
 * Required Fonts
 */
require('../assets/icomoon/fonts/enedis-icon.eot');

/**
 * Required Javascript
 */
require('@odw/lnc-web-components-ng9/polyfills-es2015.js');
require('@odw/lnc-web-components-ng9/runtime-es2015.js');
require('@odw/lnc-web-components-ng9/main-es2015.js');